<template>
	<!-- backgroundColor: '#f4f4f4', -->
	<div
		id="loadContent"
		:style="{
			overflow: 'auto',
			width: '100%'
		}"
	>
		<div style="padding: 5px; height: 100%">
		
			<div :gutter="10" style="padding: 10px">
				<a-space>
					<a-button type="primary" :icon="h(PlusOutlined)" @click="gotoNewEvents">创建会议</a-button>

					<a-input placeholder="请输入会议名称" v-model:value="queryModel.huiyi_name" />

					<el-switch active-text="已结束" inactive-text="未结束" active-color="#ff4949" inactive-color="#13ce66" :active-value="1" :inactive-value="2"></el-switch>

					<el-switch
						active-text="已删除"
						inactive-text="正常"
						active-color="#ff4949"
						inactive-color="#13ce66"
						:active-value="0"
						:inactive-value="1"
						v-model="queryModel.status"
					></el-switch>
					<a-date-picker v-model:value="queryModel.mon" picker="month" format="YYYY-MM" value-format="YYYY-MM" />

					<a-button type="primary" :icon="h(SearchOutlined)" @click="getData">搜索</a-button>

					<a-button
						danger
						:icon="h(DeleteOutlined)"
						@click="
							() => {
								queryModel = {};
								getData();
							}
						"
					>
						清除
					</a-button>
				</a-space>
			</div>

			<div
				style="padding: 10px; border-top: 1px solid #eee; overflow: auto"
				:style="{
					maxHeight: mainHeight
				}"
			>
				<el-row v-if="dataList.obj && dataList.obj.length > 0">
					<el-col v-for="d in dataList.obj" :key="d.id" style="border-bottom: 1px solid #eee; margin-bottom: 4px">
						<el-card shadow="hover" :body-style="{ padding: '10px' }">
							<el-row :gutter="20">
								<el-col :span="3" style="text-align: left">
									<!-- <img
										:src="d.会议图片"
										style="max-height: 120px; height: 100%; width: 100%"
										:style="{
											filter: d.huiyi_status == -1 ? 'grayscale(100%)' : ''
										}"
									/> -->
									
									<a-image
										v-if="d.会议图片"
										width="120px"
										height="120px"
										:style="{
											filter: d.huiyi_status == -1 ? 'grayscale(100%)' : ''
										}"
										:src="d.会议图片"
									/>
									<a-image
										v-else
										width="120px"
										height="120px"
										:style="{
											filter: d.huiyi_status == -1 ? 'grayscale(100%)' : ''
										}"
										src="data:image/png;base64,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"
									/>
									
									
									
									<div v-if="d.status == 0" class="rejectClass" style="border-top: 26px solid grey">
										<div class="rejectSpan">已删除</div>
									</div>
									<div v-else>
										<div v-if="d.huiyi_status == 1" class="rejectClass" style="border-top: 26px solid var(--primary-color)">
											<div class="rejectSpan">进行中</div>
										</div>

										<div v-else-if="d.huiyi_status == -1" class="rejectClass" style="border-top: 26px solid rgb(238, 238, 238)">
											<div class="rejectSpan" style="color: rgb(153, 153, 153)">已结束</div>
											<!-- <img :src="overImg" /> -->
										</div>

										<div v-else-if="d.huiyi_status == 0" class="rejectClass" style="border-top: 26px solid grey">
											<div class="rejectSpan">未开始</div>
										</div>
									</div>
								</el-col>
								<el-col :span="6" style="text-align: left">
									<div style="margin-bottom: 10px">
										<span
											style="font-weight: bold; font-size: 17px"
											:style="{
												color: d.huiyi_status == 1 ? 'var(--primary-color)' : d.huiyi_status == -1 ? 'rgb(153, 153, 153)' : d.huiyi_status == 0 ? 'red' : ''
											}"
										>
											{{ d.会议名称 }}
										</span>
										<span style="color: red; font-size: 13px" v-if="d.huiyi_status == 0">【未开始】</span>
										<span style="color: rgb(153, 153, 153); font-size: 13px" v-else-if="d.huiyi_status == -1">【已结束】</span>
									</div>
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px"></span>
										<span style="color: #999; font-size: 13px">{{ d.会议简介 }}</span>
									</div>
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px">{{ d.会议开始时间 }}</span>
										<span style="color: #999; font-size: 13px">~</span>
										<span style="color: #999; font-size: 13px">{{ d.会议结束时间 }}</span>
									</div>
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px"></span>
										<span style="color: #999; font-size: 13px">{{ d.详细地址 }}</span>
									</div>
								</el-col>
								<el-col :span="5" style="text-align: left">
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px">已注册人数：</span>
										<span style="font-weight: bold; font-size: 17px">{{ d.regist_count ? d.regist_count : 0 }}</span>
									</div>
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px">已签到人数：</span>
										<span style="color: #999; font-size: 13px">{{ d.sign_count ? d.sign_count : 0 }}</span>
									</div>
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px">已支付人数：</span>
										<span style="color: #999; font-size: 13px">{{ d.pay_acount ? d.pay_acount : 0 }}</span>
									</div>
								</el-col>
								<el-col :span="5" style="text-align: left">
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px">地址：</span>
										<span style="color: #999; font-size: 13px">{{ d.会议地址 }}</span>
									</div>
									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px">类型：</span>
										<span style="color: #999; font-size: 13px">{{ d.会议类型 }}</span>
									</div>

									<div style="margin-bottom: 10px">
										<span style="color: #999; font-size: 13px">注册量：</span>
										<span style="color: #999; font-size: 13px">{{ d.注册数量 }}</span>
									</div>
									<!-- <div v-for="(value, key, i) in d" :key="i">
                  <div
                    v-if="
                      key != imgName &&
                      key != 'id' &&
                      key != 'status' &&
                      key != '创建时间' &&
                      key != 'create_dtme' &&
                      key != 'huiyi_status' &&
                      key != 'huiyi_code'
                    "
                    style="height: 25px"
                  >
                    <span
                      v-if="i == 0 ? i == 0 : i == 1"
                      style="font-weight: bold; font-size: 18px"
                      >{{ key }}：</span
                    >
                    <span v-else style="color: #999; font-size: 13px"
                      >{{ key }}：</span
                    >
                    <span
                      v-if="i == 0 ? i == 0 : i == 1"
                      style="font-weight: bold; font-size: 18px"
                      >{{ value }}</span
                    >
                    <span v-else style="color: #999; font-size: 13px">{{
                      value
                    }}</span>
                  </div>
                </div> -->
								</el-col>
								<!-- <el-col :span="4">
                 <el-progress
                  :text-inside="true"
                  :stroke-width="10"
                  :percentage="70"
                /> 
              </el-col>-->
								<el-col :span="5" style="text-align: right">
									<div style="margin-bottom: 4px">
										<a-button v-if="d.status != 0" type="primary" :size="handleBtnSize" style="margin-right: 5px" :icon="h(EyeOutlined)" @click="gotoEvent(d)">
											进入
										</a-button>
									</div>
									<div style="margin-bottom: 4px">
										<a-button
											v-if="d.status != 0 && d.huiyi_status != -1"
											type="primary"
											:size="handleBtnSize"
											style="margin-right: 5px"
											:icon="h(EditOutlined)"
											@click="editEvent(d)"
										>
											编辑
										</a-button>
									</div>
									<div>
										<a-button
											v-if="d.status != 0"
											danger
											:size="handleBtnSize"
											style="margin-right: 5px"
											:icon="h(DeleteOutlined)"
											@click="deleteEvent(d.huiyi_code)"
										>
											删除
										</a-button>
									</div>
								</el-col>
							</el-row>
						</el-card>
					</el-col>
				</el-row>
				<el-empty v-else description="暂无进行中/未开始活动,点击已结束查看已结束活动,或点击新建会议,建立新会议" />
			</div>
			<div style="height: 30px; line-height: 30px" v-if="dataList && dataList.length > 0">
				<el-pagination
					:total="page.totalResult"
					:page-size="page.pageSize"
					:current-page="page.startPage"
					background
					small
					:page-sizes="[3, 6, 9]"
					layout="sizes,prev, pager, next"
					@size-change="sizeChange"
					@current-change="currentChange"
				/>
			</div>
		</div>
	</div>
</template>
<script setup>
import { ref, onMounted, reactive, h } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
import { myMixin } from './../mixin.js';
const { errorMsgBox, successMsgBox, doConfirm, apiAll, withLoading } = myMixin();
import { PlusOutlined, SearchOutlined, DeleteOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons-vue';
let size = ref('mini');
let handleBtnSize = ref('small');
let model_simple_cloud_huiyi = reactive({});
let doingHuiyi = ref(0);
let weekHuiyi = ref(0);
let monHuiyi = ref(0);
let finishHuiyi = ref(0);
let dataList = reactive({ obj: [] });
let columns = reactive([]);
let page = reactive({ pageSize: 6, startPage: 1, totalResult: 0 });
let mainHeight = ref(0);
let overImg = require('../assets/over.png');
let queryModel = reactive({ dtme_status: 0 });
let currentHuiyiId = ref(0);
onMounted(() => {
	getInit();
});
function getInit() {
	mainHeight.value = window.innerHeight - 150 + 'px';
	getData();
}
function editEvent(row) {
	window.sessionStorage.setItem('huiyiCode', row.huiyi_code);
	router.push('newEvents');
}
//进入活动
function gotoEvent(d) {
	//sessionStorage.clear();
	// window.open(
	//   window.localStorage.getItem("kaola_baseURL") +
	//     "/eventManager?thirdCode=" +
	//     d.huiyi_code +
	//     "#/event_set"
	// );

	window.open(window.location.origin + '/eventManager?thirdCode=' + d.huiyi_code );
}
function gotoNewEvents() {
	window.sessionStorage.removeItem('huiyiCode');
	router.push('newEvents');
	// //this.$router.push("newEvents");
	// this.$parent.$parent.$parent.$parent.$parent.$parent.gotoPage(
	//   "newEvents",
	//   "创建会议"
	// );
}
async function getMyDeleteEvent() {
	let data = {};
	let params = {};
	params.page = page;
	data.params = JSON.stringify(params);
	const res = await withLoading(apiAll(data, '/getMyDeleteEvent'));
	if (res.code >= 0) {
		dataList.obj = res.extra;
		page.totalResult = res.page.totalResult;
	} else {
		errorMsgBox(res.message);
	}
}
function deleteEvent(id) {
	currentHuiyiId = id;
	doConfirm('确认删除吗？', doDeleteById);
}
async function doDeleteById() {
	let data = {};
	let params = {};
	params.ephemeralParam = currentHuiyiId;
	data.params = JSON.stringify(params);
	const res = await withLoading(apiAll(data, '/deleteMyEvent'));
	if (res.code >= 0) {
		successMsgBox(res.message);
		getInit();
	} else {
		errorMsgBox(res.message);
	}
}
async function getData() {
	let data = {};
	let params = {};
	params.ephemeralParam = queryModel;
	params.page = page;
	data.params = JSON.stringify(params);
	const res = await withLoading(apiAll(data, '/getMyEvent'));
	if (res.code >= 0) {
		dataList.obj = res.extra.result;
		doingHuiyi.value = res.extra.doingHuiyiCount ? res.extra.doingHuiyiCount : 0;
		finishHuiyi.value = res.extra.finishHuiyiCount ? res.extra.finishHuiyiCount : 0;
		weekHuiyi.value = res.extra.weekHuiyiCount ? res.extra.weekHuiyiCount : 0;
		monHuiyi.value = res.extra.monHuiyiCount ? res.extra.monHuiyiCount : 0;
		page.totalResult = res.page.totalResult;
	} else {
		errorMsgBox(res.message);
	}
}
function searchData() {
	alert('这里是搜索！');
}
function clearSearch() {
	alert('清除所有搜索条件！');
}
function sizeChange(val) {
	page.startPage = 1;
	page.pageSize = val;
	getData();
}
function currentChange(val) {
	page.startPage = val;
	getData();
}
</script>
<style lang="less" scoped>
#loadContent {
	/deep/ .el-form-item {
		margin-bottom: 0;
	}
	.rejectClass {
		position: absolute;
		top: 0;
		//left: 0;
		width: 0;
		height: 0;
		border-top: 26px solid green;
		border-right:73px solid transparent;
	}
	.rejectSpan {
		position: relative;
		top: -32px;
		left: -15px;
		width: 100px;
		color: #fff;
		font-size: 24px;
		-webkit-transform: scale(0.6);
		transform: scale(0.5);
	}
}
</style>
